import React from "react";

const FitSlider = ({ fit }) => {
  const positionMap = {
    slim: "1%",
    true: "50%",
    oversized: "99%",
  };

  const markerPosition = positionMap[fit] || "50%";

  return (
    <div className="size-slider">
      <div className="slider-track"></div>
      <div
        className="slider-marker"
        style={{ left: markerPosition }}
      ></div>
      <div className="slider-labels">
        <span className="slider-labels__left">slim</span>
        <span className="slider-labels__centre">true</span>
        <span className="slider-labels__right">oversized</span>
      </div>
    </div>
  );
};

export default FitSlider;
